import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'
import { AppHeader } from '@/components/app/app-header'
import { BottomNav } from '@/components/app/bottom-nav'
import { SiteFooter } from '@/components/app/site-footer'
import { KidsDecor } from '@/components/kids/kids-decor'

// The course layout, the same in both courses: skip link, Kids decorations, the course header, the page, the footer and
// the bottom bar (below xl). The Sanskrit layout passes course='sanskrit' and its own header.
export const Layout: FC<LayoutProps> = ({ children, footer = true, className, course = 'prakrit', header }): ReactNode => {
    return (
        <div className='paper flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only z-50 rounded-lg bg-card px-4 py-2 font-medium shadow-card focus:not-sr-only focus:fixed focus:left-4 focus:top-3'
            >
                Skip to content
            </a>

            <KidsDecor />

            {header ?? <AppHeader />}

            <main id='main' tabIndex={-1} className={cn('flex-1 outline-none', !footer && 'pb-24 xl:pb-0', className)}>
                {children}
            </main>

            {footer && <div className='pb-20 xl:pb-0'><SiteFooter course={course} /></div>}

            <BottomNav course={course} />
        </div>
    )
}
